import { render, staticRenderFns } from "./procTable.vue?vue&type=template&id=1bb1dd07&"
import script from "./procTable.vue?vue&type=script&lang=js&"
export * from "./procTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports